<template>
	<div :class="containerClass" @click="onWrapperClick" v-if="metaLayout == undefined">
		<AppTopBar @menu-toggle="onMenuToggle" v-bind:pageTitle="pageTitle" />
        

        <transition name="layout-sidebar">
            <div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
                <div class="layout-logo">
                    <router-link to="/MainPage">
                        <img alt="Logo" :src="logo"/>
                    </router-link>
                </div>

                <!--<AppProfile />-->
                <AppMenu :model="menuList" @menuitem-click="onMenuItemClick" />
            </div>
        </transition>
 
		<div class="layout-main">
            <router-view />

            <!--
			<TabView v-model:activeIndex="activeIndex" :scrollable="true" @tab-change="onTabChange($event)">
                <TabPanel v-for="tab in tabs" :key="tab.label" :disabled="tab.disabled">
                    <template #header>
                        <span>{{ tab.label}}</span>
                        <i class="pi pi-times" style="margin-left:2px" @click="onClickRemoveTab($event, tab)"></i>
                    </template>
                    <keep-alive>
                        <component :is="tab.to" />
                    </keep-alive>
                </TabPanel>
            </TabView>
            -->
		</div>

		<AppConfig :layoutMode="layoutMode" :layoutColorMode="layoutColorMode" @layout-change="onLayoutChange" @layout-color-change="onLayoutColorChange"/>
        
		<!-- <AppFooter /> -->
	</div>

    <div class="layout-empty-con" v-if="metaLayout == 'public'">
        <!-- <AppEmptyTopBar /> -->
        <div class="layout-empty">
            <router-view />
        </div>
        <!--<AppFooter />-->
    </div>

    <div v-if="metaLayout == 'join'">
        <AppEmptyTopBar />
        <div class="layout-empty">
            <router-view />
        </div>
    </div>

</template>

<script>
import { ref, onMounted, computed, watch, onBeforeUpdate } from 'vue';
import { useRoute } from 'vue-router';
// import { useRouter, useRoute } from 'vue-router';
//import { useStore } from 'vuex';
import store from '@/store';  // <--- aliased path

import AppTopBar from './AppTopbar.vue';
import AppEmptyTopBar from './AppEmptyTopbar.vue';
//import AppBoardTopBar from './AppBoardTopbar.vue';
//import AppProfile from './AppProfile.vue';
import AppMenu from './AppMenu.vue';
import AppConfig from './AppConfig.vue';
//import AppFooter from './AppFooter.vue';

/*
// 메인화면(공통)
import MainPage from '@/pages/MainPage.vue';
import AccountPage from '@/pages/AccountPage.vue';
import PasswordPage from '@/pages/PasswordPage.vue';

// 시스템관리
import CodeHelpsPage from '@/pages/cm/CodeHelpsPage.vue';
import EnvCodesPage from '@/pages/cm/EnvCodesPage.vue';
import CodesPage from '@/pages/cm/CodesPage.vue';
import MenusPage from '@/pages/cm/MenusPage.vue';
import ProgramsPage from '@/pages/cm/ProgramsPage.vue';
import UsersPage from '@/pages/cm/UsersPage.vue';
import CustsPage from '@/pages/ma/CustsPage.vue';

// 업무관리
import MA201010Page from '@/pages/ma/MA201010Page.vue';
import MA201020Page from '@/pages/ma/MA201020Page.vue';
import MA201030Page from '@/pages/ma/MA201030Page.vue';
import MA201040Page from '@/pages/ma/MA201040Page.vue';
import MA201050Page from '@/pages/ma/MA201050Page.vue';
import MA201060Page from '@/pages/ma/MA201060Page.vue';
import MA201070Page from '@/pages/ma/MA201070Page.vue';
import MA201080Page from '@/pages/ma/MA201080Page.vue';
import MA201090Page from '@/pages/ma/MA201090Page.vue';

// 기준정보
import MA301010Page from '@/pages/ma/MA301010Page.vue';
import MA301020Page from '@/pages/ma/MA301020Page.vue';
import MA301030 from '@/pages/ma/MA301030.vue';
import MA301040 from '@/pages/ma/MA301040.vue';

// 원가기타
import MA502010 from '@/pages/ma/MA502010.vue';
import MA502020 from '@/pages/ma/MA502020.vue';
import MA502030 from '@/pages/ma/MA502030.vue';
import MA502040 from '@/pages/ma/MA502040.vue';
import MA502050 from '@/pages/ma/MA502050.vue';
import MA502060 from '@/pages/ma/MA502060.vue';
import MA502070 from '@/pages/ma/MA502070.vue';
import MA502071 from '@/pages/ma/MA502071.vue';
import MA502080 from '@/pages/ma/MA502080.vue';
import MA502090 from '@/pages/ma/MA502090.vue';
import MA502100 from '@/pages/ma/MA502100.vue';
import MA502110 from '@/pages/ma/MA502110.vue';
import MA502120 from '@/pages/ma/MA502120.vue';
import MA502130 from '@/pages/ma/MA502130.vue';

// 집계자료
import MA601010 from '@/pages/ma/MA601010.vue';
import MA601020 from '@/pages/ma/MA601020.vue';
import MA601030 from '@/pages/ma/MA601030.vue';
import MA601040 from '@/pages/ma/MA601040.vue';
import MA601050 from '@/pages/ma/MA601050.vue';
import MA601060 from '@/pages/ma/MA601060.vue';

// 전자신고 - 전자신고관리
import MA301050 from '@/pages/ma/MA301050.vue';
import MA301060 from '@/pages/ma/MA301060.vue';
import MA301070 from '@/pages/ma/MA301070.vue';
import MA301080 from '@/pages/ma/MA301080.vue';
import MA301090 from '@/pages/ma/MA301090.vue';
import MA301100 from '@/pages/ma/MA301100.vue';

// 분석관리
import MA401010 from '@/pages/ma/MA401010.vue';
import MA401020 from '@/pages/ma/MA401020.vue';
import MA401030 from '@/pages/ma/MA401030.vue';
import MA401040 from '@/pages/ma/MA401040.vue';
import MA401050 from '@/pages/ma/MA401050.vue';
import MA401060 from '@/pages/ma/MA401060.vue';
import MA401070 from '@/pages/ma/MA401070.vue';
import MA401080 from '@/pages/ma/MA401080.vue';
import MA401090 from '@/pages/ma/MA401090.vue';
import MA401095 from '@/pages/ma/MA401095.vue';

// 원가관리
import MA501030 from '@/pages/ma/MA501030.vue';
import MA501040 from '@/pages/ma/MA501040.vue';
import MA501050 from '@/pages/ma/MA501050.vue';
import MA501060 from '@/pages/ma/MA501060.vue';
import MA501070 from '@/pages/ma/MA501070.vue';
import MA501080 from '@/pages/ma/MA501080.vue';
import MA501090 from '@/pages/ma/MA501090.vue';

// 게시판
import MA601070 from '@/pages/ma/MA601070.vue';
import MA601080 from '@/pages/ma/MA601080.vue';
*/

export default {
    components: {
        'AppTopBar': AppTopBar,
        'AppEmptyTopBar': AppEmptyTopBar,
        //'AppBoardTopBar': AppBoardTopBar,
        //'AppProfile': AppProfile,
        'AppMenu': AppMenu,
        'AppConfig': AppConfig,
        //AppFooter': AppFooter,
        /*
        MainPage,
        AccountPage,
        PasswordPage,

        CodeHelpsPage,
        EnvCodesPage,
        CodesPage,
        MenusPage,
        ProgramsPage,
        UsersPage,
        CustsPage,

        MA201010Page,
        MA201020Page,
        MA201030Page,
        MA201040Page,
        MA201050Page,
        MA201060Page,
        MA201070Page,
        MA201080Page,
        MA201090Page,

        MA301010Page,
        MA301020Page,
        MA301030,
        MA301040,

        MA502010,
        MA502020,
        MA502030,
        MA502040,
        MA502050,
        MA502060,
        MA502070,
        MA502071,
        MA502080,
        MA502090,
        MA502100,
        MA502110,
        MA502120,
        MA502130,

        MA601010,
        MA601020,
        MA601030,
        MA601040,
        MA601050,
        MA601060,

        MA301050,
        MA301060,
        MA301070,
        MA301080,
        MA301090,
        MA301100,

        MA401010,
        MA401020,
        MA401030,
        MA401040,
        MA401050,
        MA401060,
        MA401070,
        MA401080,
        MA401090,
        MA401095,

        MA501030,
        MA501040,
        MA501050,
        MA501060,
        MA501070,
        MA501080,
        MA501090,

        MA601070,
        MA601080
        */
    },
    setup() {
        onMounted(() => {
        })

        onBeforeUpdate(() => {
            if (mobileMenuActive.value)
                addClass(document.body, 'body-overflow-hidden');
            else
                removeClass(document.body, 'body-overflow-hidden');
        }) 

        const layoutMode = ref('overlay');   /* default static */
        const layoutColorMode = ref('dark');
        const staticMenuInactive = ref(false);
        const overlayMenuActive = ref(false);
        const mobileMenuActive = ref(false);
        const isMenuClick = ref(false);
        const metaLayout = ref();
        //const menuList = ref([]);
        //const router = useRouter();
		const route = useRoute();
		//const store = useStore(); // vuex4에서 사용하는 새로운 방법

        // 탭 메뉴 화면들 - 왼쪽 메뉴바에서 클릭한 메뉴들이 동적으로 추가되어야 한다
        const tabs = ref([]);
        const activeIndex = ref(0);
        const pageTitle = ref();

        /*
        const tabs = ref([
            {
                label: '프로그램등록',
                icon: 'pi pi-fw pi-home',
                to: "ProgramsPage"
            },
            {
                label: '사용자등록',
                icon: 'pi pi-fw pi-calendar',
                to: "UsersPage"
            },
            {
                label: '업체등록',
                icon: 'pi pi-fw pi-pencil',
                to: "CustsPage"
            },
        ]);
        */

        const onWrapperClick = () => {
            if (!isMenuClick.value) {
                overlayMenuActive.value = false;
                mobileMenuActive.value = false;
            }

            isMenuClick.value = false;
        }
        
        const onMenuToggle = (event) => {
            //alert("onMenuToggle event = "+ JSON.stringify(event));
            isMenuClick.value = true;

            if (isDesktop()) {
                if (layoutMode.value === 'overlay') {
					if(mobileMenuActive.value === true) {
						overlayMenuActive.value = true;  // default true
					}

                    overlayMenuActive.value = !overlayMenuActive.value;
					mobileMenuActive.value = false;
                }
                else if (layoutMode.value === 'static') {
                    staticMenuInactive.value = !staticMenuInactive.value;
                }
            }
            else {
                mobileMenuActive.value = !mobileMenuActive.value;
            }

            // 어떤 이벤트를 명시적으로 처리하지 않은 경우, 해당 이벤트에 대한 사용자 에이전트의 기본 동작을 실행하지 않도록 지정한다
            event.preventDefault();
        }

        const onSidebarClick = () => {
            isMenuClick.value = true;
        }

        /**
         * 메뉴바에서 메뉴 클릭 시
         */
        const onMenuItemClick = (event) => {
            if (event.item && !event.item.items) {
                overlayMenuActive.value = false;
                mobileMenuActive.value = false;

                /*
                if(tabs.value.length < 10) {
                    // 메뉴바에서 최하위 메뉴 메뉴가 클릭된 경우, 해당 메뉴를 탭에 추가한다
                    //alert("event.item = "+ JSON.stringify(event.item));
                    let _icon = "pi pi-fw pi-plus"; // default icon
                    if(event.item.icon != null) {
                        _icon = event.item.icon;
                    }
                    let _to = event.item.to;
                    if(event.item.to != null) {
                        _to = event.item.to.replace("/","");
                    }

                    let newtab = {label: event.item.label, icon: _icon, to: _to, disabled: false};
                    //tabs.value = [...tabs.value, newtab];
                    tabs.value.push(newtab);

                    // 신규로 추가한 탭을 선택된 상태로 표시한다
                    activeIndex.value = tabs.value.length - 1; 
                }
                else {
                    alert("10개 이상의 화면을 표시할 수 없습니다");
                }
                */
            }
        }
        
        /**
         * 탭 변경 시
         */
        const onTabChange = (event) => {
            // 페이지의 타이틀을 탭 페이지 명으로 변경한다
            pageTitle.value = tabs.value[event.index].label;
        }
        
        /**
         * 선택된 탭을 탭 목록에서 제거한다
         */
        const onClickRemoveTab = (event, tab) => {
            var _ = require('lodash');

            // 삭제하려는 index 번호를 얻는 다. by Using lodash.findIndex
            let _Index = _.findIndex(tabs.value, (row) => {
                return row.to == tab.to;
            }, 0);

            // 삭제 후 탭 목록에 있는 다른 탭이 재 조회되는 문제가 발생한다!
            // 탭 삭제 시, 삭제하려는 탭 다음 탭이 존재하는 경우, 다음 탭이 활성화 된다
            // 단, 제일 마지막 탭 삭제 시, 마지막 이전 탭을 활성화 상태로 해주어야 한다
            if(_Index == tabs.value.length - 1) {
                // 선택된 탭을 목록에서 삭제한다
                //_.remove(tabs.value, {to: tab.to});

                // Tab 목록이 다시 화면에 표시되는 데 이때, 삭제하려는 탭 이후의 탭들에 대해서만 페이지가 reload 된다
                // 즉, 화면에서 기존 검색조건 등이 유지되지 않고 화면이 초기화된다 		
                // 대신, TabPanel에 disabled 속성을 설정하여 콘텐츠가 표시되지 않도록 탭을 비활성화 한다
                tab.disabled = true;

                activeIndex.value = tabs.value.length - 1;  // 마지막 탭이 선택되게 한다
            }
            else {  // 마지막 탭이 아닌 경우
                // 선택된 탭을 목록에서 삭제한다
                //_.remove(tabs.value, {to: tab.to});

                // Tab 목록이 다시 화면에 표시되는 데 이때, 삭제하려는 탭 이후의 탭들에 대해서만 페이지가 reload 된다
                // 즉, 화면에서 기존 검색조건 등이 유지되지 않고 화면이 초기화된다
                // 대신, TabPanel에 disabled 속성을 설정하여 콘텐츠가 표시되지 않도록 탭을 비활성화 한다
                tab.disabled = true;
                
                // 삭제하려는 탭 다음 탭이 자동으로 선택된다
                activeIndex.value = _Index;
            }

            // 이후 이벤트 onTabChange가 실행되지 않도록 한다
            event.stopPropagation();
        }
		
        const onLayoutChange = (_layoutMode) => {
			layoutMode.value = _layoutMode;
		}

		const onLayoutColorChange = (_layoutColorMode) => {
			layoutColorMode.value = _layoutColorMode;
		}

        const addClass = (element, className) => {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        }

        const removeClass = (element, className) => {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
        
        const isDesktop = () => {
            return window.innerWidth > 1024;
        }

        const isSidebarVisible = () => {
            if (isDesktop()) {
                if (layoutMode.value === 'static')
                    return !staticMenuInactive.value;
                else if (layoutMode.value === 'overlay')
                    return overlayMenuActive.value;
                else
                    return true;
            }
            else {
                return true;
            }
        }

        /*
        computed: {
            containerClass() {
                return ['layout-wrapper', {
                    'layout-overlay': this.layoutMode === 'overlay',
                    'layout-static': this.layoutMode === 'static',
                    'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                    'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                    'layout-mobile-sidebar-active': this.mobileMenuActive,
                    'p-input-filled': this.$appState.inputStyle === 'filled',
                    'p-ripple-disabled': this.$primevue.config.ripple === false
                }];
            },
            sidebarClass() {
                return ['layout-sidebar', {
                    'layout-sidebar-dark': this.layoutColorMode === 'dark',
                    'layout-sidebar-light': this.layoutColorMode === 'light'
                }];
            },
            logo() {
                return (this.layoutColorMode === 'dark') ? "images/logo.png" : "images/logo.png";
            }
        },
        */

        const containerClass = computed(() => {
			return ['layout-wrapper', {
                'layout-overlay': layoutMode.value === 'overlay',
                'layout-static': layoutMode.value === 'static',
                'layout-static-sidebar-inactive': staticMenuInactive.value && layoutMode.value === 'static',
                'layout-overlay-sidebar-active': overlayMenuActive.value && layoutMode.value === 'overlay',
                'layout-mobile-sidebar-active': mobileMenuActive.value
            }];
		});

        const sidebarClass = computed(() => {
            return ['layout-sidebar', {
                'layout-sidebar-dark': layoutColorMode.value === 'dark',
                'layout-sidebar-light': layoutColorMode.value === 'light'
            }];
        });

        const logo = computed(() => {
            return (layoutColorMode.value === 'dark') ? "images/logo_w.png" : "images/logo_w.png";
        });

        const lockicon = computed(() => {
            return (layoutMode.value === 'static') ? "pi pi-lock" : "pi pi-lock-open";
        });

        const menuList = computed(() => {
            return store.state.auth.menuList;
        });

        watch(() => store.state,
            (state) => {
                menuList.value = state.auth.menuList;
            }
        )

        watch(() => route.meta, 
            (meta)=> {
                metaLayout.value = meta.layout;  // title, layout, authRequired

                // 로그인 후, 최초 한번만 실행하게 한다
                if(meta.layout == undefined) {
                    //const user = window.sessionStorage.getItem("user");   // sessionStorage는 페이지 세션이 끝날때 제거된다

                    var user = JSON.parse(localStorage.getItem("user"));   // sessionStorage는 페이지 세션이 끝날때 제거된다
                    if(user == null || user.username == null) {
                        return;
                    }
                }
            }
        )

        return {
            layoutMode, layoutColorMode, staticMenuInactive, overlayMenuActive, mobileMenuActive, isMenuClick,
            onWrapperClick, onMenuToggle, onSidebarClick, onMenuItemClick, onClickRemoveTab, onLayoutChange, onLayoutColorChange, 
            addClass, removeClass, isDesktop, isSidebarVisible, onTabChange, 
            containerClass, sidebarClass, logo, metaLayout, menuList, lockicon, tabs, activeIndex, pageTitle, 
        }
    }
}
</script>

<style lang="scss">
@import './App.scss';
</style>
